import { TAGS } from "../constants";
import { PatientPreferredPharmacy, PatientPreferredUpdate } from "../types";
import { api } from "./api";

export const patientPreferredPharmacyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPatientPreferredPharmacy: builder.query<
      PatientPreferredPharmacy,
      number
    >({
      query: (patientId) => ({
        method: "GET",
        url: `/api/patient-preferred-pharmacies/patient/${patientId}`,
      }),
      providesTags: (_res, _error, args) => {
        return [
          {
            type: TAGS.PATIENT_PREFERRED_PHARMACY,
            id: args,
          },
        ];
      },
    }),
    updatePatientPreferredPharmacy: builder.mutation<
      PatientPreferredPharmacy,
      PatientPreferredUpdate
    >({
      query: (body) => ({
        method: "POST",
        url: `/api/patient-preferred-pharmacies`,
        body,
      }),
      invalidatesTags: (_res, _error, args) => {
        return [{ type: TAGS.PATIENT_PREFERRED_PHARMACY, id: args.patient_id }];
      },
    }),
  }),
});

export const {
  useGetPatientPreferredPharmacyQuery,
  useUpdatePatientPreferredPharmacyMutation,
} = patientPreferredPharmacyApi;
